"use strict";
exports.__esModule = true;
exports.getActivePartners = exports.getPipelineVersion = exports.getViaName = exports.getBusinessId = void 0;
exports.getBusinessId = function (state) {
    return state.business.businessId;
};
exports.getViaName = function (state) { return state.business.viaName; };
exports.getPipelineVersion = function (state) {
    return state.business.pipelineVersion;
};
exports.getActivePartners = function (state) {
    return state.business.activePartners;
};
